import { useEffect } from 'react';

const useEvent = (eventTarget: EventTarget, eventType: string, eventHandler: EventListener | EventListenerObject, options: AddEventListenerOptions | boolean | undefined = {}) => {
  useEffect(() => {
    eventTarget?.addEventListener(eventType, eventHandler, options);
    return () => {
      eventTarget?.removeEventListener(eventType, eventHandler, options);
    };
  }, [eventHandler, eventTarget, eventType, options]);
};

export default useEvent;

